const TransactionPaymentMethodEnum = {
    C: 'Card',
    Q: 'Cheque',
    S: 'Cash'
};

export default TransactionPaymentMethodEnum